import { CookiesProvider } from 'react-cookie'
import ConfigProvider from './config'
import CurrencyProvider from './currency'
import IntlProvider, { DateLocaleProvider, IntlDefaultProvider } from './intl'
import { NotificationsProvider } from './notification'
import StoreProvider from './store'
import { SWRConfig } from './swr'
import { UserDataProvider } from './user'
import TrackingsProvider from './trackings'
import SalesAgentDataProvider from './sales-agent/sales-agent-data'
import ApiRestClientProvider from './api-rest-client/api-rest-client'
import PageProvider from './page/page'

const Essentials = ({
	children,
	cookiesProps,
	store,
	currency,
	config,
	defaultTranslations,
	translations,
	locale,
	swrConfigProps,
	userAuthenticated,
	salesAgentAuthenticated,
	userGroup,
	salesAgentGroup,
	pageProps,
}) => (
	<CookiesProvider {...cookiesProps}>
		<ConfigProvider value={config}>
			<StoreProvider storeCode={store}>
				<CurrencyProvider currencyCode={currency}>
					<IntlDefaultProvider translations={defaultTranslations}>
						<IntlProvider locale={locale} translations={translations}>
							<DateLocaleProvider>
								<NotificationsProvider>
									<UserDataProvider authenticated={userAuthenticated} userGroup={userGroup}>
										<SalesAgentDataProvider
											salesAgentAuthenticated={salesAgentAuthenticated}
											salesAgentGroup={salesAgentGroup}
										>
											<ApiRestClientProvider>
												<SWRConfig {...swrConfigProps}>
													<PageProvider pageProps={pageProps}>
														<TrackingsProvider>{children}</TrackingsProvider>
													</PageProvider>
												</SWRConfig>
											</ApiRestClientProvider>
										</SalesAgentDataProvider>
									</UserDataProvider>
								</NotificationsProvider>
							</DateLocaleProvider>
						</IntlProvider>
					</IntlDefaultProvider>
				</CurrencyProvider>
			</StoreProvider>
		</ConfigProvider>
	</CookiesProvider>
)

export default Essentials
